import { tickerItems } from "@/mocks/site";

export default function TickerBar() {
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <div className="border-y border-background-200 bg-background-100">
      <div className="mx-auto flex max-w-content items-center gap-4 px-4 py-3 md:px-6">
        <span className="flex shrink-0 items-center gap-2 rounded-md bg-primary-600 px-3 py-1.5 text-xs font-label font-semibold text-background-50">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-60"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50"></span>
          </span>
          快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track">
            {doubled.map((item, i) => (
              <span
                key={`${item}-${i}`}
                className="flex shrink-0 items-center gap-3 pr-10 text-sm font-label text-foreground-700"
              >
                <i className="ri-flashlight-line text-accent-600" aria-hidden="true"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}